import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Box, FormControlLabel } from "@mui/material";
import { USER_SETTINGS } from "../../../constants/UserConstants.ts";
import { useAppStore } from "../../../hooks/useStores.tsx";
import { getTgEvaluationTour } from "../../../pages/NewTG/Models/Viewer/Evaluation/tgEvaluationTourSteps.tsx";
import BriaButton from "../../common/BriaButton/BriaButton.tsx";
import BriaCheckbox from "../../common/BriaCheckbox/BriaCheckbox.tsx";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup.tsx";
import styles from "./TgEvaluationTutorialPopup.module.scss";

const TgEvaluationTutorialPopup = () => {
	const { uiStore, tgStore, authStore, tourStore } = useAppStore();
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation.onboarding" });
	const [dontShowAgain, setDontShowAgain] = useState(false);

	const dismissTutorial = async () => {
		await authStore.user?.updateSettings(USER_SETTINGS.hideTgEvaluationTutorial, true);
		await authStore.user?.refreshSettings();
	};

	const handleClose = async () => {
		dontShowAgain && (await dismissTutorial());
		uiStore.hideDialog("TgEvaluationTutorialDialog");
	};

	const initializeTutorial = async () => {
		dontShowAgain && (await dismissTutorial());
		uiStore.hideDialog("TgEvaluationTutorialDialog");
		tgStore.tgModelPlaygroundStore.isTutorialActive = true;
		tourStore.start(getTgEvaluationTour());
	};

	return (
		<ConfirmationPopup
			open={uiStore.TgEvaluationTutorialDialog}
			onClose={handleClose}
			title={t("firstModal.title")}
			description={t("firstModal.description")}
			maxWidth="600px"
			hideActions
		>
			<Box className={styles.rowContainer}>
				<FormControlLabel
					control={
						<BriaCheckbox checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} />
					}
					label={t("firstModal.checkboxLabel")}
					className={styles.checkboxLabel}
				/>
				<Box className={styles.buttonsContainer}>
					<BriaButton buttonType="primaryMedium" onClick={initializeTutorial}>
						{t("firstModal.confirmButton")}
					</BriaButton>
					<BriaButton buttonType="textSmall" onClick={handleClose}>
						{t("firstModal.cancelButton")}
					</BriaButton>
				</Box>
			</Box>
		</ConfirmationPopup>
	);
};

export default observer(TgEvaluationTutorialPopup);
